import React from "react";
import "./style.css";
import InstagramLogo from "./assets/InstagramLogo";
import LinkedInLogo from "./assets/LinkedInLogo";
import GithubLogo from "./assets/GithubLogo";
import FloatingCard from "../common/FloatingCard";

function Introduction() {
  return (
    <div className="introduction-big-container">
      <FloatingCard container="container" card="card" content={<Content />} />
    </div>
  );
}

function Content() {
  return (
    <>
      <div className="title-container">
        <div className="picture-container">
          <div className="profile-picture-container">
            <img src={"/profile.JPG"} className="profile-picture" />
          </div>
        </div>
        <div className="text-container">
          <h2 className="title">Hey! I'm Daren Nathaniel Janto</h2>
          <h2 className="welcome">Welcome to my website!</h2>
        </div>
      </div>
      <div className="description-container">
        <p className="about_me">
          A penultimate undergraduate student majoring Computer Science in
          Nanyang Technological University
        </p>
        <p className="interest">
          I have a big interest in Frontend Development, Cloud Computing, and
          DevOps related work!
        </p>
        <p className="bible_quote">
          “I thank my God upon every remembrance of you.” -Philippians 1:3
        </p>
      </div>
      <div className="social-medias-container">
        <div className="social-medias">
          <div className="instagram_container">
            <InstagramLogo
              className="logo"
              href={"https://www.instagram.com/darenathaniel/"}
            />
          </div>
          <div className="linkedin_container">
            <LinkedInLogo
              className="logo"
              href={
                "https://www.linkedin.com/in/daren-nathaniel-janto-30b7881b6/"
              }
            />
          </div>
          <div className="github_container">
            <GithubLogo
              className="logo"
              href={"https://github.com/darennathaniel"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Introduction;
